
// SVG Icon: feedback
export default { id: "terriajs-feedback" };
export const id = "terriajs-feedback";
export const name = "feedback";
